export var getters = {
    showNavbar: state => {
        return state.showNavbar
    },
    getTheme: state => {
        return state.theme
    },
    getIsLoading: state => {
        return state.isLoading
    },
    getComponents: state => {
        return state.components
    },
    getLatestIncidents: state => {
        return state.latestIncidents
    },
    getIncident: state => {
        return state.incident
    },
    getStatus: state => {
        return state.status
    },
    getReportData: state => {
        return state.reportData
    },
    getBaseApiUrl: state => {
        return state.baseApiUrl
    },
    getIncidents: state => {
        return state.incidents
    },
    getComponent: state => {
        return state.component
    }
}



// WEBPACK FOOTER //
// ./src/store/getters.js